import { FormGroup } from "@angular/forms";

export class UnlockCaseModel {
    
    constructor(values?: Partial<UnlockCaseModel>) {
        Object.assign(this, values);
    }
    
    caseSysId!: string;
    lockedById!: string;

    public static parseValues(json: any) {
        if(!json) {
            return new UnlockCaseModel();
        }

        const responseDetails = {
            caseSysId: json.caseSysId,
            lockedById: json.lockedById
        };

        return new UnlockCaseModel(responseDetails);
    }

    public static parseFormGroup(form: FormGroup) {
        if(!form) {
            return new UnlockCaseModel();
        }

        const responseDetails = {
            caseSysId: form.get('caseSysId')?.value,
            lockedById: form.get('lockedById')?.value
        };

        return new UnlockCaseModel(responseDetails);
    }
}
